const { convertArrayToCSV } = require('convert-array-to-csv')

const arrayToCSV = data => {
  data = data.map(item => {
    return {
      _id: item._id || '',
      sku: item.sku || '',
      title: item.title || '',
      type: item.type || '', // Fix: Handle null/undefined
      size: item.size || '',
      CustomerPrice:
        item.price !== null && item.price !== undefined ? item.price : '',
      GLN: item.GLN !== null && item.GLN !== undefined ? item.GLN : '',
      SupplierPrice:
        item.OMSPrice !== null && item.OMSPrice !== undefined
          ? item.OMSPrice
          : '',
      UoM: item.UoM || '',
      pricedBy: item.pricedBy || '',
      hasVat:
        item.hasVat !== null && item.hasVat !== undefined
          ? item.hasVat
            ? 'TRUE'
            : 'FALSE'
          : '',
      supplier: item.supplier ? item.supplier.title || '' : '',
      cloudinaryImageId: item.cloudinaryImageId || '',
      archive: item.isDeleted ? 'TRUE' : 'FALSE',
    }
  })

  const csvFromArrayOfObjects = convertArrayToCSV(data)
  return csvFromArrayOfObjects
}

const arrayToCSVSupplier = data => {
  data = data.map(item => {
    return {
      id: item._id,
      title: item.supplierTitle,
      secondTitle: item?.supplier?.secondTitle,
      email: item?.supplier?.emailAddress,
      venueTitle: item?.venue?.title,
      venueCode: item?.venue?.code,
    }
  })

  const csvFromArrayOfObjects = convertArrayToCSV(data)
  return csvFromArrayOfObjects
}

export { arrayToCSV, arrayToCSVSupplier }
